// Recovered compiled webpack factory 3729. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { M: () => d });
  var n = i(21391),
    s = i(40479),
    r = i(37899),
    o = i(68745),
    a = i(12709),
    l = i(38708),
    h = i(33452),
    u = i(76066);
  class d extends a.b {
    constructor() {
      (super(...arguments), (this.type = "html"), (this.renderInstance = h.e));
    }
    readValueFromInstance(t, e) {
      if (s.f.has(e)) return this.projection?.isProjecting ? (0, r.zs)(e) : (0, r.Ib)(t, e);
      {
        let i = window.getComputedStyle(t),
          s = ((0, n.j4)(e) ? i.getPropertyValue(e) : i[e]) || 0;
        return "string" == typeof s ? s.trim() : s;
      }
    }
    measureInstanceViewportBox(t, { transformPagePoint: e }) {
      return (0, o.m)(t, e);
    }
    build(t, e, i) {
      (0, l.O)(t, e, i.transformTemplate);
    }
    scrapeMotionValuesFromProps(t, e, i) {
      return (0, u.x)(t, e, i);
    }
  }
}
